export const placesFetchedFields = ['displayName', 'addressComponents', 'location'];
